import React, { useState, useEffect } from 'react';
import StationTag from './components/station-tag';
import Toast from '../../components/toast';
import EquipTypeTag from './components/equip-type-tag';
import ActivityTag from './components/activity-tag';
import { jumpPage, wxInit, myInit } from '../../utils/common';
import './index.less';

const StationItem = (props) => {
  const { station, showDistance, withLine = true } = props;
  const UA = navigator.userAgent || "";
  const isXPApp = /xiaopeng/i.test(UA); // 小鹏app
  const isWX = /micromessenger/i.test(UA); // 微信
  const isWXApp = isWX && /miniProgram/i.test(UA); // 微信小程序
  const isMyApp = /AliApp/i.test(UA) && /miniProgram/i.test(UA); // 支付宝小程序

  const onGoDetail = (stationId: number | string) => {
    if (isXPApp) {
      jumpPage(`xiaopeng://charging/station/detail?id=${stationId}`);
    } else if (isWXApp) {
      wxInit().then(wx =>
        wx.miniProgram.navigateTo({
          url: `/charging/pages/station-detail/index?stationId=${stationId}`
        })
      );
    } else if (isMyApp) {
      myInit().then(my =>
        my.navigateTo({
          url: `/charging/pages/station-detail/index?stationId=${stationId}`
        })
      );
    } else {
      let env = 'release'
      if (window.location.href.indexOf('static.deploy-test.xiaopeng.com') !== -1) {
        env = 'develop';
      }
      window.location.href = `https://static.xiaopeng.com/apps/charge-web/jump-to-wx-mini.html?page=charging/pages/station-detail/index&query=stationId%3D${stationId}&version=${env}`;
    }
  };

  return (
    <div
      className={`station-card-wrap ${station?.stationAvailabilityDesc ? 'disabled' : ''}`}
      key={station?.stationId}
      onClick={() => onGoDetail(station?.stationId)}
    >
      <div className='title-row'>
        <span className='name'>{station?.stationName}</span>
        {
          (showDistance && !!station?.distance) ? (
            <div className='location-info'>
              <img className='location-icon' alt='' src={`https://s.xiaopeng.com/xp-charge/mini/common/navigator-pointer.png`}/>
              <span className='distance'>{station?.distance}km</span>
            </div>
          ) : null
        }
      </div>
      <StationTag
        disabled={!!station?.stationAvailabilityDesc}
        useInDetail={false}
        stationLabelList={station?.stationLabelList}
        className='station-tag'
      />
      <div className='pile-info-row'>
        <div className='price-info'>
          <span className='prefix'>￥ </span>
          <span className='num'>{station?.stationBillingInfo?.minTotalPrice || '--'}</span>
          <span className='unit'>/度 {
            (station?.stationBillingInfo?.minTotalPrice !== station?.stationBillingInfo?.totalPrice) ? '起' : ''
          }</span>
        </div>
        <div className='pile-status'>
          {
            station?.stationEquipOverViewList?.length > 0 && station?.stationEquipOverViewList.map((eItem, eIndex) => (
              <div key={eIndex + eItem?.type}>
                <div className='equipTypeList'>
                  <EquipTypeTag
                    type={eItem?.chargePowerType}
                    name={eItem?.typeName}
                    isDisabled={!!station?.stationAvailabilityDesc}
                  />
                  <div className='status'>
                    <span className='idle'>闲 {eItem?.freeNums}</span>
                    <span className='all'>/{eItem?.nums}</span>
                  </div>
                </div>
              </div>
            ))
          }
        </div>
      </div>
      <ActivityTag
        disabled={!!station?.stationAvailabilityDesc}
        type={station?.stationActivityInfo?.activityType}
        activityPriceDesc={station?.stationActivityInfo?.activityPriceDesc}
        activityAbbr={station?.stationActivityInfo?.activityAbbr}
        className='station-activity-tag'
        showBackUpText={false}
      />
      {
        station?.stationAvailabilityDesc ? (
          <div className='error-tip'>{station?.stationAvailabilityDesc}</div>
        ) : null
      }
      { withLine && <div className='devide-bottom-line'></div>}
    </div>
  );
};

export default StationItem;
